<template>
    <div class="content with-pagination">
        <router-view @refresh="refresh()"></router-view>
        <header class="content-header">
            <div class="wrapper">

                <div>
                    <h1>Logs</h1>
                    <p>Listing des logs</p>

                    <div class="datagrid-results"><strong>{{paginator.total}}</strong> Résultats trouvés</div>
                </div>

                <div class="actions">
                    <ul>
<!--                        <li v-if="$aclInterfaceValidator('weeboxcore.queue.import')"><button-action  type="import"/></li>
                        <li v-if="$aclInterfaceValidator('weeboxcore.queue.create')">
                           <button-action  type="create"/>
                        </li>
                        -->
                    </ul>
                </div>

            </div>
        </header>

        <filters v-model="filters" :paginator="paginator" :tabs="tabsFilter" @refresh="refresh()" @setFilter="setFilter" active-advanced-filter="true"></filters>

        <div class="content-body">

            <section>

                <no-results v-model="resources" :clear="resetFilter"></no-results>

                <div v-if="resources && resources.length" class="datagrid" :class="paginator.listing">
                    <div class="datagrid-header">
                        <div>
                            <div></div>
                            <div class="picture"></div>
                            <div>
                              <datagrid-sort :data="[{name:'Destinataire(s)', value:'to'}]" v-model="paginator"></datagrid-sort>
                            </div>
                            <div>
                              <datagrid-sort :data="[{name:'Expéditeur', value:'sent_from'}]" v-model="paginator"></datagrid-sort>
                            </div>
                            <div>
                              <datagrid-sort :data="[{name:'Coûts', value:'sent_cost'}]" v-model="paginator"></datagrid-sort>
                            </div>
                            <div>
                              <datagrid-sort :data="[{name:'Provider', value:'provider'}]" v-model="paginator"></datagrid-sort>
                            </div>
                            <div>
                              <datagrid-sort :data="[{name:'Queue Type', value:'queuable_type'},{name:'Queue ID', value:'queuable_id'}]" v-model="paginator"></datagrid-sort>
                            </div>
                            <div>
                              <datagrid-sort :data="[{name:'Date d\'exécution', value:'updated_at'}]" v-model="paginator"></datagrid-sort>
                            </div>
                            <div>Statut</div>
                            <div><span>Scopes</span></div>
                            <div></div>
                        </div>
                    </div>
                    <div class="datagrid-body">
                        <div v-for="item in resources" v-bind:class="setClassDataRaw( 'weeboxcore.payment.view', item.id )">
                            <div></div>
                            <div class="picture no-radius">
                                <figure>
                                  <img :src="$iconFolder + '/' + item.type + '.svg'" v-if="item.type"/>
                                  <img :src="$iconFolder + '/file.svg'" v-else/>
                                </figure>
                            </div>
                            <div data-field="to">
                              <strong v-if="item.person" style="margin-bottom:0.25em;">{{ item.person.name }}</strong>
                              <strong>{{ item.to }}</strong>
                              <p v-if="item.sent_body">{{ item.sent_body }}</p>
                              <p v-else>Pas d'aperçu disponible</p>
                            </div>
                            <div data-field="sent_from">{{ item.sent_from_name }} {{ item.sent_from }}</div>
                            <div data-field="sent_cost">{{ item.sent_cost }}</div>
                            <div data-field="provider">{{ item.provider }}</div>
                            <div data-field="queueable_id queueable_type">{{ item.queuable_type }}<br>{{ item.queuable_id }}</div>
                            <div data-field="updated_at">
                              <datetime v-model="item.terminated_at" v-if="item.terminated_at"></datetime>
                              <datetime v-model="item.cancelled_at" v-if="item.cancelled_at"></datetime>
                              <datetime v-model="item.scheduled_at" v-if="item.scheduled_at"></datetime>
                            </div>
                            <div>
                              <i class="icon icon-order-success status-completed" v-if="item.terminated_at"></i>
                              <i class="icon icon-order-cancel status-error" v-else-if="item.cancelled_at"></i>
                              <i class="icon icon-order-pending status-pending" v-else></i>
                            </div>
                            <div data-field="scope"><scopes v-model="item.scopes" v-if="item.scopes"></scopes></div>
                            <div></div>
                        </div>
                    </div>
                </div>
            </section>

            <component-paginator v-model="paginator" v-on:refresh="refresh"></component-paginator>

        </div>
    </div>
</template>
<script>
    import QueueService from './QueueService.js';
    import Index from '../../../layouts/Index.vue';

    export default {
        extends: Index,
        data () {
            return {
              tabsFilter: [
                {
                  slug: '',
                  name: 'Tout'
                },
                {
                  slug: 'sms',
                  name: 'Messages (SMS)'
                },
                {
                  slug: 'email',
                  name: 'E-mail'
                }
              ],
            }
        },
        mounted: function(){
            this.refresh()
        },
        methods: {
            getResource: function(){
                return QueueService;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/config/queue/Index.vue